import React, { FC } from "react";

import { Tooltip } from "@mui/material";

import config from "@/config";
import { StyledFixedBottomButton } from "@/styles/components/button/StyledFixedBottomButton";

const EnvironmentDisplay: FC = () => {
    if (!config.IS_PROD && config.ENV !== "local") {
        return (
            <Tooltip title={<span style={{ fontSize: "12px" }}>{config.BUILD.BUILD_DATE}</span>} placement="top">
                <StyledFixedBottomButton
                    style={{
                        background: config.ENVIRONMENT_COLOR,
                        right: "0",
                        padding: "5px 15px",
                        fontSize: "14px",
                    }}
                >
                    {config.ENV === "pr" ? "PR PREVIEW" : config.ENV}
                </StyledFixedBottomButton>
            </Tooltip>
        );
    }
};

export default EnvironmentDisplay;
